import React, { useState } from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
/* ── Mobile horizontal swipe carousel ── */
function MobileSwipeCarousel({ children, itemWidth = "75vw", gap = 16 }) {
  const trackRef = React.useRef(null);
  const [activeIndex, setActiveIndex] = React.useState(0);
  const count = React.Children.count(children);

  const handleScroll = () => {
    if (!trackRef.current) return;
    const scrollLeft = trackRef.current.scrollLeft;
    const itemW = trackRef.current.scrollWidth / count;
    setActiveIndex(Math.round(scrollLeft / itemW));
  };

  return (
    <div style={{ position: "relative" }}>
      <div
        ref={trackRef}
        onScroll={handleScroll}
        style={{
          display: "flex",
          gap: `${gap}px`,
          overflowX: "auto",
          scrollSnapType: "x mandatory",
          WebkitOverflowScrolling: "touch",
          scrollbarWidth: "none",
          msOverflowStyle: "none",
          paddingBottom: "8px",
          paddingLeft: "6%",
          paddingRight: "6%",
        }}
      >
        {React.Children.map(children, (child) => (
          <div
            style={{
              flex: `0 0 ${itemWidth}`,
              scrollSnapAlign: "start",
            }}
          >
            {child}
          </div>
        ))}
      </div>
      {/* dot indicators */}
      {count > 1 && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "6px",
            marginTop: "14px",
          }}
        >
          {Array.from({ length: count }).map((_, i) => (
            <div
              key={i}
              style={{
                width: activeIndex === i ? 20 : 7,
                height: 7,
                borderRadius: 4,
                background: activeIndex === i ? "#c9982a" : "#ddd",
                transition: "all 0.3s",
              }}
            />
          ))}
        </div>
      )}
    </div>
  );
}
/* suppress webkit scrollbar inside carousel */
const mobileCarouselStyle = `
  .ac-swipe-track::-webkit-scrollbar { display: none; }
`;

const pageVariants = {
  initial: { opacity: 0, scale: 0.96, filter: "blur(6px)" },
  animate: { opacity: 1, scale: 1, filter: "blur(0px)" },
  exit: { opacity: 0, x: -60, filter: "blur(4px)" },
};
function Blob({ style }) {
  return (
    <motion.div
      animate={{ y: [0, -20, 0], rotate: [0, 8, 0] }}
      transition={{ repeat: Infinity, duration: 6, ease: "easeInOut" }}
      style={{
        position: "absolute",
        borderRadius: "60% 40% 55% 45% / 50% 60% 40% 55%",
        opacity: 0.18,
        ...style,
      }}
    />
  );
}
const projects = [
  {
    img: "/wm 1.jpeg",
    label: "WALL MURALS",
    to: "/services/wall-murals",
  },
  {
    img: "/ws 1.jpeg",
    label: "WALL SCULPTURES",
    to: "/services/wall-sculptures",
  },
  {
    img: "/fc 1.jpeg",
    label: "FACADE ART",
    to: "/services/facades-glass",
  },
  {
    img: "/f 2.jpeg",
    label: "LARGE CANVAS",
    to: "/services/large-canvas",
  },
  {
    img: "/hd 4.jpeg",
    label: "HOME DECORS",
    to: "/services/home-decors",
  },
  {
    img: "/grc 1.jpeg",
    label: "FIBERGLASS & GRC",
    to: "/services/fiberglass-grc",
  },
  {
    img: "/c 2.jpeg",
    label: "ARTISTIC CONTAINERS",
    to: "/services/artistic-containers",
  },
  {
    img: "/w 1.jpeg",
    label: "WEDDING ART",
    to: "/services/wedding-art",
  },
];

function FeaturedProjects() {
  const [start, setStart] = useState(0);
  const visible = 4;
  const canPrev = start > 0;
  const canNext = start < projects.length - visible;

  return (
    <section
      style={{ background: "#fff", padding: "80px 6%", overflow: "hidden" }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
          flexWrap: "wrap",
          gap: "16px",
          marginBottom: "36px",
        }}
      >
        <section
          style={{
            background: "#fff",
            padding: "2px 1% 50px",
          }}
        >
          <div
            style={{
              maxWidth: "950px",
              margin: "0 auto",
            }}
          >
            <p
              style={{
                color: "#b8882a",
                fontWeight: 700,
                fontSize: "0.78rem",
                letterSpacing: "3px",
                textTransform: "uppercase",
                marginBottom: "10px",
              }}
            >
              ARTISTIC SPACES ACROSS INDIA
            </p>

            <h2
              style={{
                fontFamily: "var(--font-serif)",
                fontSize: "clamp(1.6rem,3vw,2.4rem)",
                fontWeight: 700,
                color: "#111",
                lineHeight: 1.2,
                margin: 0,
              }}
            >
              Where Creativity Meets Spaces Across Chennai & India.
            </h2>

            <p
              style={{
                color: "#666",
                fontSize: "1.3rem",
                lineHeight: 1.5,
                maxWidth: "850px",
                margin: "0 ",
              }}
            >
              Artem Clava partners with businesses, educational institutions,
              hospitality brands, developers, and homeowners to create custom
              murals, sculptural installations, facade art, and creative
              environments. Based in Chennai and serving clients across India,
              we deliver artistic solutions that transform ordinary spaces into
              memorable experiences.
            </p>
          </div>
        </section>
        <div>
          <p
            style={{
              color: "#b8882a",
              fontWeight: 700,
              fontSize: "0.78rem",
              letterSpacing: "3px",
              textTransform: "uppercase",
              marginBottom: "10px",
            }}
          >
            FEATURED PROJECTS
          </p>
          <h2
            style={{
              fontFamily: "var(--font-serif)",
              fontSize: "clamp(1.6rem,3vw,2.4rem)",
              fontWeight: 700,
              color: "#111",
              lineHeight: 1.2,
              margin: 0,
            }}
          >
            Transforming Ideas into
            <br />
            Landmark Spaces
          </h2>
        </div>
        <Link
          to="/services"
          style={{ textDecoration: "none", alignSelf: "center" }}
        >
          <motion.button
            whileHover={{ background: "#111", color: "#fff" }}
            style={{
              padding: "10px 22px",
              border: "1.5px solid #111",
              background: "transparent",
              color: "#111",
              fontWeight: 600,
              fontSize: "0.78rem",
              letterSpacing: "1.5px",
              cursor: "pointer",
              transition: "all 0.3s",
            }}
          >
            VIEW FULL PORTFOLIO
          </motion.button>
        </Link>
      </div>
      <div style={{ position: "relative" }}>
        <button
          onClick={() => setStart((s) => Math.max(0, s - 1))}
          disabled={!canPrev}
          style={{
            position: "absolute",
            left: "-18px",
            top: "45%",
            transform: "translateY(-50%)",
            zIndex: 10,
            width: 36,
            height: 36,
            borderRadius: "50%",
            border: "1.5px solid #ddd",
            background: "#fff",
            cursor: canPrev ? "pointer" : "not-allowed",
            fontSize: "1.2rem",
            opacity: canPrev ? 1 : 0.3,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
          }}
        >
          ‹
        </button>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(4, 1fr)",
            gap: "18px",
          }}
        >
          {projects.slice(start, start + visible).map((p, i) => (
            <motion.div
              key={p.to}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.07 }}
            >
              <Link
                to={p.to}
                style={{ textDecoration: "none", display: "block" }}
              >
                <motion.div
                  whileHover={{ y: -6 }}
                  style={{ cursor: "pointer" }}
                >
                  <div
                    style={{
                      width: "100%",
                      aspectRatio: "1 / 1",
                      overflow: "hidden",
                      borderRadius: "6px",
                      position: "relative",
                    }}
                  >
                    <img
                      src={p.img}
                      alt={p.label}
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        transition: "transform 0.5s ease",
                      }}
                      onMouseEnter={(e) =>
                        (e.currentTarget.style.transform = "scale(1.08)")
                      }
                      onMouseLeave={(e) =>
                        (e.currentTarget.style.transform = "scale(1)")
                      }
                    />
                    <div
                      style={{
                        position: "absolute",
                        inset: 0,
                        background: "rgba(184,136,42,0.15)",
                        opacity: 0,
                        transition: "opacity 0.3s",
                      }}
                      onMouseEnter={(e) =>
                        (e.currentTarget.style.opacity = "1")
                      }
                      onMouseLeave={(e) =>
                        (e.currentTarget.style.opacity = "0")
                      }
                    />
                  </div>
                  <p
                    style={{
                      textAlign: "center",
                      marginTop: "10px",
                      fontSize: "0.76rem",
                      fontWeight: 700,
                      letterSpacing: "1.5px",
                      color: "#333",
                    }}
                  >
                    {p.label}
                  </p>
                </motion.div>
              </Link>
            </motion.div>
          ))}
        </div>
        <button
          onClick={() =>
            setStart((s) => Math.min(projects.length - visible, s + 1))
          }
          disabled={!canNext}
          style={{
            position: "absolute",
            right: "-18px",
            top: "45%",
            transform: "translateY(-50%)",
            zIndex: 10,
            width: 36,
            height: 36,
            borderRadius: "50%",
            border: "1.5px solid #ddd",
            background: "#fff",
            cursor: canNext ? "pointer" : "not-allowed",
            fontSize: "1.2rem",
            opacity: canNext ? 1 : 0.3,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
          }}
        >
          ›
        </button>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          gap: "8px",
          marginTop: "28px",
        }}
      >
        {Array.from({ length: projects.length - visible + 1 }).map((_, i) => (
          <button
            key={i}
            onClick={() => setStart(i)}
            style={{
              width: start === i ? 24 : 8,
              height: 8,
              borderRadius: 4,
              border: "none",
              background: start === i ? "#b8882a" : "#ddd",
              cursor: "pointer",
              padding: 0,
              transition: "all 0.3s",
            }}
          />
        ))}
      </div>
    </section>
  );
}
const industries = [
  { icon: "🏢", label: "Corporate Offices" },
  { icon: "🎓", label: "Schools & Educational Institutions" },
  { icon: "🏨", label: "Hotels & Resorts" },
  { icon: "🍽️", label: "Restaurants & Cafés" },
  { icon: "🏥", label: "Healthcare Facilities" },
  { icon: "🛍️", label: "Retail Spaces" },
  { icon: "🏠", label: "Residential Projects" },
  { icon: "🌳", label: "Public Spaces" },
];
function IndustriesSection() {
  const [isMobile, setIsMobile] = React.useState(
    typeof window !== "undefined" && window.innerWidth < 768
  );
  React.useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handler);
    return () => window.removeEventListener("resize", handler);
  }, []);

  const cards = industries.map((ind, i) => (
    <motion.div
      key={i}
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ delay: i * 0.06 }}
      whileHover={{ y: -4, boxShadow: "0 8px 24px rgba(0,0,0,0.1)" }}
      style={{
        background: "#fff",
        border: "1px solid #e8e0d0",
        borderRadius: "8px",
        padding: "28px 16px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "10px",
        cursor: "default",
        transition: "all 0.3s",
        ...(isMobile ? { width: "100%", minHeight: "120px" } : { flex: "0 0 calc(12.5% - 14px)", minWidth: "120px" }),
      }}
    >
      <span style={{ fontSize: "2rem" }}>{ind.icon}</span>
      <span
        style={{
          fontSize: "0.78rem",
          fontWeight: 600,
          color: "#333",
          lineHeight: 1.35,
          textAlign: "center",
          whiteSpace: "normal",
        }}
      >
        {ind.label}
      </span>
    </motion.div>
  ));

  return (
    <section
      style={{
        background: "#f9f7f4",
        padding: "80px 0",
        textAlign: "center",
      }}
    >
      <p
        style={{
          color: "#b8882a",
          fontWeight: 700,
          fontSize: "0.78rem",
          letterSpacing: "3px",
          textTransform: "uppercase",
          marginBottom: "12px",
          padding: "0 6%",
        }}
      >
        INDUSTRIES WE SERVE
      </p>
      <h2
        style={{
          fontFamily: "var(--font-serif)",
          fontSize: "clamp(1.8rem,3vw,2.6rem)",
          fontWeight: 700,
          color: "#111",
          marginBottom: "50px",
          padding: "0 6%",
        }}
      >
        Creative Solutions for Every Industry
      </h2>
      {isMobile ? (
        <MobileSwipeCarousel itemWidth="60vw" gap={14}>
          {cards}
        </MobileSwipeCarousel>
      ) : (
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "16px",
            maxWidth: "1200px",
            margin: "0 auto",
            paddingBottom: "8px",
            justifyContent: "center",
            padding: "0 6%",
          }}
        >
          {cards}
        </div>
      )}
    </section>
  );
}
const reasons = [
  { icon: "🎨", title: "Custom Concept Development" },
  { icon: "🔩", title: "Multi-Material Expertise" },
  { icon: "📋", title: "End-to-End Project Execution" },
  { icon: "📈", title: "Scalable Solutions" },
  { icon: "🗺️", title: "Pan-India Projects" },
  { icon: "✨", title: "Durable & Premium Finishes" },
  { icon: "👥", title: "Creative + Technical Team" },
  { icon: "⏰", title: "On-Time Delivery" },
];
function WhyChooseSection() {
  const [isMobile, setIsMobile] = React.useState(
    typeof window !== "undefined" && window.innerWidth < 768
  );
  React.useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handler);
    return () => window.removeEventListener("resize", handler);
  }, []);

  const cards = reasons.map((r, i) => (
    <motion.div
      key={i}
      initial={{ opacity: 0, scale: 0.9 }}
      whileInView={{ opacity: 1, scale: 1 }}
      viewport={{ once: true }}
      transition={{ delay: i * 0.07 }}
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "12px",
        ...(isMobile
          ? { width: "100%", padding: "20px 10px" }
          : { flex: "0 0 110px", minWidth: "100px" }),
      }}
    >
      <div
        style={{
          width: 62,
          height: 62,
          borderRadius: "50%",
          border: "1.5px solid #c9982a",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: "1.5rem",
          background: "rgba(201,152,42,0.07)",
          flexShrink: 0,
        }}
      >
        {r.icon}
      </div>
      <span
        style={{
          fontSize: "0.78rem",
          fontWeight: 600,
          color: "#333",
          lineHeight: 1.4,
          textAlign: "center",
        }}
      >
        {r.title}
      </span>
    </motion.div>
  ));

  return (
    <section
      style={{ background: "#fff", padding: "80px 0", textAlign: "center" }}
    >
      <p
        style={{
          color: "#b8882a",
          fontWeight: 700,
          fontSize: "0.78rem",
          letterSpacing: "3px",
          textTransform: "uppercase",
          marginBottom: "12px",
          padding: "0 6%",
        }}
      >
        WHY CHOOSE ARTEM CLAVA
      </p>
      <h2
        style={{
          fontFamily: "var(--font-serif)",
          fontSize: "clamp(1.8rem,3vw,2.6rem)",
          fontWeight: 700,
          color: "#111",
          marginBottom: "50px",
          padding: "0 6%",
        }}
      >
        Why Leading Brands Choose Artem Clava
      </h2>
      {isMobile ? (
        <MobileSwipeCarousel itemWidth="50vw" gap={20}>
          {cards}
        </MobileSwipeCarousel>
      ) : (
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "24px",
            maxWidth: "1200px",
            margin: "0 auto",
            paddingBottom: "8px",
            justifyContent: "center",
            padding: "0 6%",
          }}
        >
          {cards}
        </div>
      )}
    </section>
  );
}
const processSteps = [
  {
    num: "01",
    title: "Consultation",
    desc: "Understanding your vision and requirements",
  },
  {
    num: "02",
    title: "Concept Creation",
    desc: "Creative concepts and ideas come to life",
  },
  {
    num: "03",
    title: "Design Approval",
    desc: "Refining and finalizing the design",
  },
  {
    num: "04",
    title: "Fabrication & Production",
    desc: "High-quality craftsmanship and creation",
  },
  {
    num: "05",
    title: "Installation",
    desc: "Expert installation with attention to every detail",
  },
  {
    num: "06",
    title: "Final Delivery",
    desc: "Ensuring complete satisfaction and lasting impact",
  },
];
function CreativeProcessSection() {
  const [isMobile, setIsMobile] = React.useState(
    typeof window !== "undefined" && window.innerWidth < 768
  );
  React.useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handler);
    return () => window.removeEventListener("resize", handler);
  }, []);

  const cards = processSteps.map((step, i) => (
    <motion.div
      key={i}
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ delay: i * 0.1 }}
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "14px",
        padding: isMobile ? "24px 16px" : "0 8px",
        position: "relative",
        zIndex: 1,
        ...(isMobile && {
          background: "#f9f7f4",
          borderRadius: "10px",
          border: "1px solid #ede8df",
          width: "100%",
        }),
      }}
    >
      <div
        style={{
          width: 56,
          height: 56,
          borderRadius: "50%",
          background: "#c9982a",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontWeight: 800,
          fontSize: "0.95rem",
          color: "#fff",
          flexShrink: 0,
        }}
      >
        {step.num}
      </div>
      <strong style={{ fontSize: "0.85rem", color: "#111", lineHeight: 1.35 }}>
        {step.title}
      </strong>
      <p style={{ fontSize: "0.76rem", color: "#666", lineHeight: 1.5, margin: 0 }}>
        {step.desc}
      </p>
    </motion.div>
  ));

  return (
    <section
      style={{
        background: "#fff",
        padding: "80px 0",
        textAlign: "center",
        borderTop: "1px solid #f0ece4",
      }}
    >
      <p
        style={{
          color: "#b8882a",
          fontWeight: 700,
          fontSize: "0.78rem",
          letterSpacing: "3px",
          textTransform: "uppercase",
          marginBottom: "12px",
          padding: "0 6%",
        }}
      >
        OUR CREATIVE PROCESS
      </p>
      <h2
        style={{
          fontFamily: "var(--font-serif)",
          fontSize: "clamp(1.8rem,3vw,2.6rem)",
          fontWeight: 700,
          color: "#111",
          marginBottom: "60px",
          padding: "0 6%",
        }}
      >
        From Vision to Reality
      </h2>
      {isMobile ? (
        <MobileSwipeCarousel itemWidth="72vw" gap={16}>
          {cards}
        </MobileSwipeCarousel>
      ) : (
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(140px, 1fr))",
            gap: "32px 16px",
            maxWidth: "1100px",
            margin: "0 auto",
            position: "relative",
            padding: "0 6%",
          }}
        >
          {cards}
        </div>
      )}
    </section>
  );
}
function ImpactSection() {
  const stats = [
    { icon: "🎨", num: "100+", label: "Artworks Created" },
    { icon: "🏛️", num: "75+", label: "Projects Completed" },
    { icon: "😊", num: "100+", label: "Happy Clients" },
    { icon: "⭐", num: "6+", label: "Years of Experience" },
    { icon: "📍", num: "20+", label: "Cities Served" },
  ];

  const [isMobile, setIsMobile] = React.useState(
    typeof window !== "undefined" && window.innerWidth < 768
  );
  React.useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handler);
    return () => window.removeEventListener("resize", handler);
  }, []);

  const cards = stats.map((s, i) => (
    <motion.div
      key={i}
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ delay: i * 0.1 }}
      style={
        isMobile
          ? {
              background: "rgba(255,255,255,0.06)",
              borderRadius: "10px",
              border: "1px solid rgba(201,152,42,0.3)",
              padding: "28px 16px",
              width: "100%",
            }
          : {}
      }
    >
      <div style={{ fontSize: "2.2rem", marginBottom: "6px" }}>{s.icon}</div>
      <div
        style={{
          fontFamily: "var(--font-serif)",
          fontSize: "2.6rem",
          fontWeight: 800,
          color: "#c9982a",
          lineHeight: 1,
        }}
      >
        {s.num}
      </div>
      <div
        style={{
          color: "rgba(255,255,255,0.65)",
          fontSize: "0.85rem",
          marginTop: "6px",
        }}
      >
        {s.label}
      </div>
    </motion.div>
  ));

  return (
    <section
      style={{
        backgroundImage:
          "url('https://images.unsplash.com/photo-1513364776144-60967b0f800f?w=1400&q=60')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        position: "relative",
        padding: "80px 0",
        textAlign: "center",
      }}
    >
      <div
        style={{
          position: "absolute",
          inset: 0,
          background: "rgba(10,6,20,0.85)",
        }}
      />
      <div style={{ position: "relative", zIndex: 1 }}>
        <p
          style={{
            color: "#c9982a",
            fontWeight: 700,
            fontSize: "0.78rem",
            letterSpacing: "3px",
            textTransform: "uppercase",
            marginBottom: "50px",
            padding: "0 6%",
          }}
        >
          OUR IMPACT IN NUMBERS
        </p>
        {isMobile ? (
          <MobileSwipeCarousel itemWidth="55vw" gap={16}>
            {cards}
          </MobileSwipeCarousel>
        ) : (
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(140px, 1fr))",
              gap: "40px",
              maxWidth: "900px",
              margin: "0 auto",
              padding: "0 6%",
            }}
          >
            {cards}
          </div>
        )}
      </div>
    </section>
  );
}
const blogPosts = [
  {
    to: "/blog/wall-murals-commercial-spaces",
    tag: "Commercial Spaces",
    tagColor: "#c9982a",
    title: "How Wall Murals Can Transform Commercial Spaces",
    excerpt:
      "A well-designed commercial wall mural communicates your brand story, creates a unique atmosphere, and leaves a lasting impression on visitors.",
    readTime: "5 min read",
    image: "/commercial.jpeg",
  },
  {
    to: "/blog/school-wall-painting-ideas",
    tag: "Educational Spaces",
    tagColor: "#0ab5a8",
    title: "School Wall Painting Ideas That Inspire Learning",
    excerpt:
      "Bright, creative, and educational wall paintings can transform plain walls into interactive learning tools that spark curiosity and imagination.",
    readTime: "6 min read",
    image: "/child.jpeg",
  },
  {
    to: "/blog/custom-murals-office-interiors",
    tag: "Office Design",
    tagColor: "#7c5cbf",
    title: "Benefits of Custom Murals for Office Interiors",
    excerpt:
      "Custom murals create an atmosphere that reflects your company's culture, vision, and values — making your workspace unique and memorable.",
    readTime: "5 min read",
    image: "/officespace.jpeg",
  },
  {
    to: "/blog/wall-mural-cost-chennai",
    tag: "Pricing Guide",
    tagColor: "#f26540",
    title: "Wall Mural Cost in Chennai: Complete Pricing Guide (2026)",
    excerpt:
      "Understanding what shapes mural pricing helps you plan your project better. Here's a complete breakdown of every factor that affects cost.",
    readTime: "4 min read",
    image: "/budget.jpeg",
  },
];
function BlogSection() {
  const [isMobile, setIsMobile] = React.useState(
    typeof window !== "undefined" && window.innerWidth < 768
  );
  React.useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handler);
    return () => window.removeEventListener("resize", handler);
  }, []);

  const BlogCard = ({ post, i }) => (
    <motion.div
      key={i}
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ delay: i * 0.08 }}
      style={{ height: "100%" }}
    >
      <Link to={post.to} style={{ textDecoration: "none", display: "block", height: "100%" }}>
        <motion.div
          whileHover={{ y: -6, boxShadow: "0 16px 40px rgba(0,0,0,0.10)" }}
          transition={{ duration: 0.25 }}
          style={{
            background: "#fdf9f4",
            border: "1px solid #ede8df",
            borderRadius: "12px",
            padding: "32px 28px",
            height: "100%",
            display: "flex",
            flexDirection: "column",
            gap: "14px",
            cursor: "pointer",
            transition: "box-shadow 0.25s",
            boxSizing: "border-box",
          }}
        >
          <div style={{ width: "100%", height: "180px", overflow: "hidden", borderRadius: "12px", marginBottom: "8px" }}>
            <img
              src={post.image}
              alt={post.title}
              style={{ width: "100%", height: "100%", objectFit: "cover", transition: "transform 0.4s ease" }}
              onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.05)")}
              onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
            />
          </div>
          <span
            style={{
              display: "inline-block",
              background: `${post.tagColor}18`,
              color: post.tagColor,
              fontSize: "0.72rem",
              fontWeight: 700,
              letterSpacing: "1.5px",
              textTransform: "uppercase",
              padding: "3px 10px",
              borderRadius: "20px",
              alignSelf: "flex-start",
            }}
          >
            {post.tag}
          </span>
          <h3
            style={{
              fontFamily: "var(--font-serif)",
              fontSize: "1.15rem",
              fontWeight: 700,
              color: "#1a0a2e",
              lineHeight: 1.35,
              margin: 0,
            }}
          >
            {post.title}
          </h3>
          <p style={{ color: "#666", fontSize: "0.9rem", lineHeight: 1.7, margin: 0, flex: 1 }}>
            {post.excerpt}
          </p>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              marginTop: "auto",
              paddingTop: "14px",
              borderTop: "1px solid #ede8df",
            }}
          >
            <span style={{ fontSize: "0.78rem", color: "#999", fontWeight: 500 }}>
              {post.readTime}
            </span>
            <span style={{ fontSize: "0.82rem", fontWeight: 700, color: post.tagColor, letterSpacing: "0.5px" }}>
              Read More →
            </span>
          </div>
        </motion.div>
      </Link>
    </motion.div>
  );

  return (
    <section
      style={{
        background: "#fff",
        padding: "90px 0",
        borderTop: "1px solid #f0ece4",
      }}
    >
      <div style={{ textAlign: "center", marginBottom: "52px", padding: "0 6%" }}>
        <p
          style={{
            color: "#b8882a",
            fontWeight: 700,
            fontSize: "0.78rem",
            letterSpacing: "3px",
            textTransform: "uppercase",
            marginBottom: "12px",
          }}
        >
          INSIGHTS & IDEAS
        </p>
        <h2
          style={{
            fontFamily: "var(--font-serif)",
            fontSize: "clamp(1.8rem,3vw,2.6rem)",
            fontWeight: 700,
            color: "#111",
            margin: "0 auto",
            maxWidth: 560,
            lineHeight: 1.25,
          }}
        >
          From Our Studio
        </h2>
        <p
          style={{
            color: "#666",
            marginTop: "14px",
            fontSize: "1rem",
            lineHeight: 1.7,
            maxWidth: 500,
            margin: "14px auto 0",
          }}
        >
          Guides, ideas, and inspiration for transforming spaces with art.
        </p>
      </div>

      {isMobile ? (
        <MobileSwipeCarousel itemWidth="80vw" gap={18}>
          {blogPosts.map((post, i) => (
            <BlogCard key={i} post={post} i={i} />
          ))}
        </MobileSwipeCarousel>
      ) : (
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
            gap: "24px",
            maxWidth: "1200px",
            margin: "0 auto",
            padding: "0 6%",
          }}
        >
          {blogPosts.map((post, i) => (
            <BlogCard key={i} post={post} i={i} />
          ))}
        </div>
      )}
    </section>
  );
}

const faqs = [
  {
    q: "How much does a wall mural cost in Chennai?",
    a: "The cost depends on wall size, design complexity, materials used, and project location. Contact us for a customized quote.",
  },
  {
    q: "Can Artem Clava create custom art installations for offices, hotels, and commercial spaces?",
    a: "Yes. We design and execute custom art installations, commercial art solutions, and large-scale creative projects for offices, hotels, restaurants, retail spaces, educational institutions, and public environments.",
  },
  {
    q: "How long does it take to complete a mural project?",
    a: "Most mural projects take between a few days and several weeks depending on size and design requirements.",
  },
  {
    q: "Do you provide mural services outside Chennai?",
    a: "Yes, we undertake mural projects across India.",
  },
  {
    q: "Do you handle end-to-end art and installation projects?",
    a: "Yes. Our team manages the complete process, including consultation, concept development, design, fabrication, execution, and final installation.",
  },
];
function FAQSection() {
  const [open, setOpen] = useState(null);
  return (
    <section
      style={{
        padding: "90px 5%",
        background:
          "linear-gradient(150deg,#0f0520 0%,#1a0a2e 60%,#0a1828 100%)",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <motion.div
        animate={{ scale: [1, 1.15, 1], opacity: [0.3, 0.5, 0.3] }}
        transition={{ repeat: Infinity, duration: 8, ease: "easeInOut" }}
        style={{
          position: "absolute",
          width: 400,
          height: 400,
          borderRadius: "50%",
          background: "radial-gradient(circle,#7c5cbf,transparent 70%)",
          top: "-100px",
          right: "-80px",
          pointerEvents: "none",
          mixBlendMode: "screen",
        }}
      />
      <motion.div
        animate={{ scale: [1, 1.2, 1], opacity: [0.2, 0.4, 0.2] }}
        transition={{
          repeat: Infinity,
          duration: 10,
          delay: 2,
          ease: "easeInOut",
        }}
        style={{
          position: "absolute",
          width: 300,
          height: 300,
          borderRadius: "50%",
          background: "radial-gradient(circle,#c9982a,transparent 70%)",
          bottom: "-60px",
          left: "-60px",
          pointerEvents: "none",
          mixBlendMode: "screen",
        }}
      />
      <motion.p
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        style={{
          fontFamily: "'Satisfy',cursive",
          color: "#c9982a",
          fontSize: "1.1rem",
          letterSpacing: "3px",
          textAlign: "center",
          marginBottom: 12,
        }}
      >
        ✦ Got Questions? ✦
      </motion.p>
      <motion.h2
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        style={{
          fontFamily: "'Cormorant Garamond',serif",
          fontSize: "clamp(2rem,5vw,3.5rem)",
          fontWeight: 700,
          fontStyle: "italic",
          color: "#fff",
          textAlign: "center",
          marginBottom: 50,
        }}
      >
        Frequently Asked <span style={{ color: "#c9982a" }}>Questions</span>
      </motion.h2>
      <div
        style={{
          maxWidth: 800,
          margin: "0 auto",
          display: "flex",
          flexDirection: "column",
          gap: 16,
        }}
      >
        {faqs.map((faq, i) => (
          <motion.div
            key={i}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: i * 0.08, duration: 0.5 }}
            style={{
              borderRadius: 18,
              overflow: "hidden",
              border: "1px solid rgba(255,255,255,0.1)",
              background:
                open === i ? "rgba(201,152,42,0.08)" : "rgba(255,255,255,0.04)",
              transition: "background 0.3s",
            }}
          >
            <button
              onClick={() => setOpen(open === i ? null : i)}
              style={{
                width: "100%",
                background: "transparent",
                border: "none",
                padding: "20px 24px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                cursor: "pointer",
                gap: 16,
                textAlign: "left",
              }}
            >
              <span
                style={{
                  fontFamily: "'DM Sans',sans-serif",
                  fontWeight: 600,
                  fontSize: "1rem",
                  color: open === i ? "#c9982a" : "#fff",
                  lineHeight: 1.4,
                  flex: 1,
                }}
              >
                {faq.q}
              </span>
              <motion.span
                animate={{ rotate: open === i ? 45 : 0 }}
                transition={{ duration: 0.25 }}
                style={{
                  flexShrink: 0,
                  width: 30,
                  height: 30,
                  borderRadius: "50%",
                  background:
                    open === i
                      ? "linear-gradient(135deg,#c9982a,#f0c84a)"
                      : "rgba(255,255,255,0.1)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: open === i ? "#1a0a1e" : "#fff",
                  fontSize: "1.2rem",
                  fontWeight: 300,
                }}
              >
                +
              </motion.span>
            </button>
            <motion.div
              initial={false}
              animate={{
                height: open === i ? "auto" : 0,
                opacity: open === i ? 1 : 0,
              }}
              transition={{ duration: 0.3, ease: "easeInOut" }}
              style={{ overflow: "hidden" }}
            >
              <div
                style={{
                  padding: "0 24px 22px",
                  color: "rgba(255,255,255,0.7)",
                  lineHeight: 1.8,
                  fontSize: "0.95rem",
                  fontWeight: 300,
                }}
              >
                {faq.a}
              </div>
            </motion.div>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
function Home() {
  return (
    <>
    <style>{`div[style*="overflowX: auto"]::-webkit-scrollbar, div[style*="overflow-x: auto"]::-webkit-scrollbar { display: none; }`}</style>
    <motion.div
      variants={pageVariants}
      initial="initial"
      animate="animate"
      exit="exit"
      transition={{ duration: 0.7, ease: "easeInOut" }}
    >
      <section
        style={{
          minHeight: "100vh",
          backgroundImage:
            "url('https://images.unsplash.com/photo-1513364776144-60967b0f800f?w=1600')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          position: "relative",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            position: "absolute",
            inset: 0,
            background: "rgba(26,10,46,0.72)",
          }}
        />
        <Blob
          style={{
            width: 400,
            height: 400,
            background: "var(--fuchsia)",
            top: "-80px",
            left: "-100px",
          }}
        />
        <Blob
          style={{
            width: 320,
            height: 320,
            background: "var(--teal)",
            bottom: "60px",
            right: "-60px",
            animationDelay: "2s",
          }}
        />
        <Blob
          style={{
            width: 200,
            height: 200,
            background: "var(--gold)",
            top: "50%",
            right: "15%",
            animationDelay: "1s",
          }}
        />
        <div
          style={{
            position: "relative",
            zIndex: 2,
            textAlign: "center",
            width: "90%",
            maxWidth: "900px",
          }}
        >
          <motion.h1
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.4, duration: 0.9, ease: "easeOut" }}
            style={{
              fontFamily: "var(--font-serif)",
              fontStyle: "italic",
              fontWeight: 900,
              fontSize: "clamp(1rem,6vw,2.5rem)",
              lineHeight: 1.1,
              color: "#fff",
              marginBottom: "24px",
            }}
          >
            Transform Spaces with Custom Murals & Art Installations
            <br />
            <span
              style={{
                background:
                  "linear-gradient(135deg, var(--gold), var(--fuchsia), var(--lavender))",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
              }}
            >
              Artem Clava India
            </span>
          </motion.h1>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.7, duration: 0.7 }}
            style={{
              color: "rgba(255,255,255,0.8)",
              fontSize: "clamp(0.9rem,2vw,1.1rem)",
              lineHeight: 1.7,
              maxWidth: 540,
              margin: "0 auto 32px",
            }}
          >
            Artem Clava is a creative art and design company delivering murals,
            sculptures, installations and artistic solutions that inspire,
            engage and leave a lasting impression.
          </motion.p>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 1.0, duration: 0.6 }}
            style={{
              display: "flex",
              gap: "20px",
              justifyContent: "center",
              flexWrap: "wrap",
            }}
          >
            <Link to="/services" style={{ textDecoration: "none" }}>
              <motion.button
                whileHover={{
                  scale: 1.06,
                  boxShadow: "0 0 30px rgba(232,160,32,0.5)",
                }}
                whileTap={{ scale: 0.97 }}
                style={{
                  padding: "13px 28px",
                  border: "2px solid #c9982a",
                  borderRadius: "4px",
                  background: "#c9982a",
                  color: "#fff",
                  fontSize: "0.9rem",
                  fontFamily: "var(--font-sans)",
                  fontWeight: 700,
                  letterSpacing: "1.5px",
                  cursor: "pointer",
                  textTransform: "uppercase",
                }}
              >
                View Portfolio
              </motion.button>
            </Link>
            <Link to="/contact" style={{ textDecoration: "none" }}>
              <motion.button
                whileHover={{
                  scale: 1.06,
                  background: "rgba(255,255,255,0.12)",
                }}
                whileTap={{ scale: 0.97 }}
                style={{
                  padding: "13px 28px",
                  border: "2px solid rgba(255,255,255,0.6)",
                  borderRadius: "4px",
                  background: "transparent",
                  color: "#fff",
                  fontSize: "0.9rem",
                  fontFamily: "var(--font-sans)",
                  fontWeight: 700,
                  letterSpacing: "1.5px",
                  cursor: "pointer",
                  textTransform: "uppercase",
                  transition: "background 0.3s",
                }}
              >
                Get In Touch
              </motion.button>
            </Link>
          </motion.div>
        </div>
        <motion.div
          animate={{ y: [0, 10, 0] }}
          transition={{ repeat: Infinity, duration: 1.6 }}
          style={{
            position: "absolute",
            bottom: "40px",
            left: "50%",
            transform: "translateX(-50%)",
            zIndex: 2,
            color: "rgba(255,255,255,0.5)",
            fontSize: "1.5rem",
          }}
        >
          ↓
        </motion.div>
      </section>

      <FeaturedProjects />
      <IndustriesSection />
      <WhyChooseSection />
      <CreativeProcessSection />
      <ImpactSection />
      <BlogSection />
      <FAQSection />
    </motion.div>
    </>
  );
}
export default Home;
